import React from 'react';
import { Box, Skeleton } from '@mui/material';

interface SkeletonRowProps {
  visibleCount: number;
  gridTemplate: string;
}

/**
 * Строка-заглушка для скелетон-анимации во время загрузки таблицы.
 * Повторяет сеточную структуру реальных строк — только видимые колонки.
 */
const SkeletonRow: React.FC<SkeletonRowProps> = ({ visibleCount, gridTemplate }) => (
  <Box sx={{
    display: 'grid',
    gridTemplateColumns: gridTemplate,
    gap: 1, px: 2, py: 0.75,
    borderBottom: '1px solid', borderColor: 'divider',
    minWidth: 'max-content', alignItems: 'center',
  }}>
    {Array.from({ length: visibleCount }).map((_, i) => (
      <Skeleton key={i} variant="text" width={i === 3 ? '90%' : '80%'} height={18} />
    ))}
  </Box>
);

export default SkeletonRow;